import OverlayTips from "../OverlayTips"

function SettingsPageOverlayTipsManager(userGroupsEnabled, userRatesAvailable)
{
    PageOverlayTipsManager.call(this);
    this._namingGroupTitle = userGroupsEnabled ? "tips.settings.naming.ugr":"tips.settings.naming";
    this._overtimeGroupTitle = userRatesAvailable ? "tips.settings.overtime":"tips.settings.overtime.rates_off";
}

SettingsPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this._addTitleTip($(".namingGroupTitle"), this._namingGroupTitle);
        this._addTitleTip($(".dateTimeGroupTitle"), "tips.settings.date_time");
        this._addTitleTip($(".timeTrackGroupTitle"), "tips.settings.time_track");
        this._addTitleTip($(".ptoGroupTitle"), "tips.settings.pto");
        this._addTitleTip($(".sickDaysGroupTitle"), "tips.settings.sick_days");
        this._addTitleTip($(".overtimeGroupTitle"), this._overtimeGroupTitle);
        this._addTitleTip($(".formatsGroupTitle"), "tips.settings.formats");
        this._addTitleTip($(".accessGroupTitle"), "tips.settings.access");
        this._addTitleTip($(".passwordGroupTitle"), "tips.settings.password");
        this._addTitleTip($(".notificationsGroupTitle"), "tips.settings.notifications");
        this._addTitleTip($(".emailGroupTitle"), "tips.settings.email");
    },

    _addTitleTip: function(e, messageKey)
    {
        this.add(e, {
            messageKey: messageKey,
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetY: 0
            }
        });
    }
});

export default SettingsPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/SettingsPageOverlayTipsManager.js